import { createSlice } from "@reduxjs/toolkit";

// Initial state with trips and a currentTripId
const initialState = {
  trips: {},
  currentTripId: null,
};

// Create a Redux slice for trips
const allTripsSlice = createSlice({
  name: "allTrips", // Name of the slice
  initialState, // The initial state defined above
  reducers: {
    // Set all trips
    setTrips(state, action) {
      // Convert the array of trips to an object keyed by trip_id
      state.trips = action.payload.reduce((acc, trip) => {
        acc[trip.TRIP_ID] = trip;
        return acc;
      }, {});
    },

    // Reducer to update or add a single trip
    updateTrip(state, action) {
      const updatedTrip = action.payload;
      // Update the trip in the state using trip_id as the key
      state.trips[updatedTrip.TRIP_ID] = updatedTrip;
    },

    // Set the currently selected trip ID
    setCurrentTrip(state, action) {
      state.currentTripId = action.payload;
    },
  },
});

// Export action creators for use in components
export const { setTrips, updateTrip, setCurrentTrip } = allTripsSlice.actions;

// Selector to get current trip details
export const selectCurrentTrip = (state) => {
  const { currentTripId, trips } = state.allTrips;
  return trips[currentTripId] || null;
};

// Export reducer to be added to the store
export const allTripsReducer = allTripsSlice.reducer;

